"use client";

import { useMenuFormatting } from "./NavigationFormatting";
import type { NavigationBreakpoint } from "@/hooks/useMinWidth";

export default function NavigationToggle({
  ref,
  open,
  controls,
  variant,
  appearance,
  bp,
  desktopHidden,
  mobileHidden,
  reserveSpace,
  onClick,
}: {
  ref?: React.Ref<HTMLButtonElement>;
  open: boolean;
  controls: string;
  variant: "icon" | "iconText" | "text";
  appearance: "default" | "floating" | "classic";
  bp: NavigationBreakpoint;
  desktopHidden?: boolean;
  mobileHidden?: boolean;
  reserveSpace?: boolean;
  onClick: () => void;
}) {
  const format = useMenuFormatting();
  return (
    <button
      {...format("button")}
      ref={ref}
      type="button"
      className="re-nav-toggle"
      data-appearance={appearance}
      data-variant={variant}
      data-bp={bp}
      data-open={open || undefined}
      data-desktop-hidden={desktopHidden || undefined}
      data-mobile-hidden={mobileHidden || undefined}
      data-reserve-space={reserveSpace || undefined}
      aria-label={variant === "icon" ? "Menu" : undefined}
      aria-expanded={open}
      aria-controls={controls}
      onClick={onClick}
    >
      {variant !== "text" && (
        <span className="re-nav-toggle-icon" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      )}
      {variant !== "icon" && (
        <span className="re-nav-toggle-label">
          <span className="re-nav-toggle-label-measure" aria-hidden="true">
            Menu
          </span>
          <span className="re-nav-toggle-label-measure" aria-hidden="true">
            Luk
          </span>
          <span>{open ? "Luk" : "Menu"}</span>
        </span>
      )}
    </button>
  );
}
